import './Spinner.scss'
// HTML & CSS courtesy of https://loading.io/css/

export default function Spinner(){
    return (
<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    )
}